import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';

import { AuthProvider } from '@/auth/auth-context';
import { PharmacyScopeProvider } from '@/auth/pharmacy-scope';
import { IS_DEV } from '@/lib/env';
import { queryClient } from '@/lib/query-client';
import { router } from '@/routes';
import { ThemeProvider } from '@/theme/theme-provider';

import './styles.css';

const container = document.getElementById('root');
if (!container) throw new Error('Missing #root — check index.html');

/*
 * Provider order matters: AuthProvider issues queries, so it must sit inside
 * QueryClientProvider; PharmacyScopeProvider reads the caller's assigned
 * pharmacies from /auth/me, so it sits inside AuthProvider.
 */
createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <AuthProvider>
          <PharmacyScopeProvider>
            <RouterProvider router={router} />
          </PharmacyScopeProvider>
        </AuthProvider>
      </ThemeProvider>
      {IS_DEV ? <ReactQueryDevtools initialIsOpen={false} /> : null}
    </QueryClientProvider>
  </StrictMode>,
);
